import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, reactive, watch } from 'vue';
import InfoBlock from 'ah-common-lib/src/common/components/InfoBlock.vue';
import { IndividualType, OnboardingIndividualInfo } from 'ah-api-gateways';
import { makeMemberForm } from './reviewForms';
import { setState, toDataModel, updateModel } from 'ah-common-lib/src/form/helpers';
import { FormDefinition } from 'ah-common-lib/src/form/interfaces';
import { isEmpty } from 'lodash';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { useAuthStore } from '@/app/store/authStore';
import { catchError, mergeMap } from 'rxjs/operators';
import { waitForCQRSEntityChange } from 'ah-requests';
import { of } from 'rxjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignatoryDetailsReview',
  props: {
    model: null,
    editable: { type: Boolean, default: false }
  },
  emits: ["update:model"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:model', value: OnboardingIndividualInfo): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { model: OnboardingIndividualInfo, editable: boolean };

const requestManager = useRequestManager().manager;

const services = getServices();

const authStore = useAuthStore();

const toast = getCurrentInstance()?.proxy.$toast;





const state = reactive<{ editing: boolean }>({ editing: false });

const signatoryForm = reactive<FormDefinition>({
  form: makeMemberForm(),
  validation: null,
});

const isEditable = computed(() => props.editable !== false);

const isReadonly = computed(() => !isEmpty(props.model.user));

const isRetrievedInviteDetails = computed(() => props.model.retrievedInviteDetails);

const permissionLabel = computed(() => {
  if (props.model.type === IndividualType.CLIENT_ADMIN) {
    return 'Superuser';
  } else if (props.model.proposedPermissions && props.model.proposedPermissions.length > 0) {
    return 'Custom permissions';
  } else {
    return 'None';
  }
});

const infoBlock = computed(() => [
  { label: 'Title', key: 'title', cols: 4 },
  { label: 'Name', key: 'firstName', cols: 4 },
  { label: 'Surname', key: 'lastName', cols: 4 },
  { label: 'Email Address', key: 'email', cols: 4 },
  { label: 'Mobile Number', key: 'phoneNumber', cols: 4 },
  { label: 'Requested Permissions', key: 'permissions', value: permissionLabel.value, cols: 4 },
]);

function save() {
  const clientId = authStore.loggedInIdentity!.client!.id;

  requestManager
    .currentOrNew(
      'saveSignatory',
      services.registration
        .editProposedUser(props.model.id!, clientId, { ...props.model, ...toDataModel(signatoryForm.form) })
        .pipe(
          mergeMap((idEntity) =>
            waitForCQRSEntityChange(idEntity, () => services.individual.getIndividual(idEntity.id)).pipe(
              catchError(() => of(props.model))
            )
          )
        )
    )
    .subscribe((individual) => {
      toast?.success('Authorised signatory details changed successfully');
      state.editing = false;
      emit('update:model', individual);
    });
}

watch(
  () => props.model,
  () => {
    updateModel(signatoryForm.form, { ...props.model, permissions: permissionLabel.value });
  },
  { immediate: true }
);

watch(
  isReadonly,
  () => {
    setState(signatoryForm.form, 'readonly', isReadonly.value);
  },
  { immediate: true }
);

return { __sfc: true,requestManager, services, authStore, toast, props, emit, state, signatoryForm, isEditable, isReadonly, isRetrievedInviteDetails, permissionLabel, infoBlock, save, InfoBlock }
}

})